import WColorMixin from '../w-color-mixin'
import WCardFormActionsMixin from './w-card-form-actions-mixin'
import WFormMixin from './w-form-mixin'
import WFormErrorAlertsMixin from './w-form-error-alerts-mixin'
import WDescriptionMixin from '../w-description-mixin'

/**
 * @mixin
 */
export default {
    name: 'WCardForm',
    mixins: [
        WColorMixin,
        WCardFormActionsMixin,
        WFormMixin,
        WFormErrorAlertsMixin,
        WDescriptionMixin
    ],
    props: {
        /**
         * Text alignment, defaults to left
         */
        align: {
            type: String,
            default: 'left'
        },
        /**
         * Event triggered when the close button in the toolbar is clicked
         */
        closeButtonEvent: {
            type: String,
            default: 'close'
        },
        /**
         * Icon displayed in the toolbar to close the form
         */
        closeButtonIcon: {
            type: String,
            default: 'close'
        },
        /**
         * Set to true to remove padding
         */
        dense: {
            type: Boolean,
            default: false
        },
        /**
         * Toggle form elevation
         */
        flat: {
            type: Boolean,
            default: true
        },
        /**
         * Hide form actions.  If true this will enable the `actions` slot
         */
        hideActions: {
            type: Boolean,
            default: false
        },
        /**
         * Hide form content
         */
        hideContent: {
            type: Boolean,
            default: false
        },
        /**
         * Hide the close button in the toolbar
         */
        hideCloseButton: {
            type: Boolean,
            default: false
        },
        /**
         * path to logo image.  If set this will display centered in the form.
         */
        logoSrc: {
            type: String,
            default: ''
        },
        /**
         * Default css applied to the logo
         */
        logoStyle: {
            type: [Object, String],
            default: () => ({
                display: 'block',
                height: '60px',
                margin: '16px auto 36px auto',
                'max-width': '250px'
            })
        },
        /**
         * Default margin css applied to the form
         */
        marginStyle: {
            type: Object,
            default: () => ({
                'margin-left': 'auto',
                'margin-right': 'auto'
            })
        },
        /**
         * Make toolbar clickable and emit close event
         */
        toolbarClickable: {
            type: Boolean,
            default: false
        },
        /**
         * Set the card width.
         * Pass in a boolean to inherit the width from the parent.
         */
        width: {
            type: [String, Number, Boolean],
            default: true
        },
        /**
         * Set the card max width.
         */
        maxWidth: {
            type: [String, Number, Boolean],
            default: true
        },
        /**
         * The title of the form
         */
        title: {
            type: String,
            default: 'Form'
        }
    },
    computed: {
        defaultWCardFormEvents () {
            const vm = this
            return {
                ...vm.wFormEvents,
                ...vm.wCardFormActionsEvents,
                [vm.closeButtonEvent]: vm.handleClose
            }
        },
        defaultWCardFormProps () {
            const vm = this
            return vm.$props
        },
        wCardFormProps () {
            return this.defaultWCardFormProps
        },
        wCardFormEvents () {
            return this.defaultWCardFormEvents
        }
    },
    methods: {
        handleClose () {
            /**
             * Emit close button event
             * @event this.closeButtonEvent
             */
            this.$emit(this.closeButtonEvent)
        }
    }
}
